<div class="widget-products widget">
    <h4 class="widget__title">{{ header | translate }}</h4>
    <div class="widget-products__list">
        <div *ngFor="let product of products" class="widget-products__item gap-4">
            <div class="image-container">
                <a [routerLink]="['/sector',product.sectorSlug,'product', product.seo?.slug]" class="image-link">
                    <img class="image" [src]="product.images?.url" alt="">
                </a>
            </div>
            <!-- <div class="widget-products__image">
                    <a [routerLink]="['/sector',product.sectorSlug,'product', product.seo?.slug]" class="product-image__body">
                        <img class="product-image__img" [src]="product.images?.url" alt="">
                    </a>
            </div> -->
            <div class="widget-products__info">
                <div class="widget-products__name">
                    <a [routerLink]="['/sector',product.sectorSlug,'product', product.seo?.slug]">{{ translateHlper.localize(product.name) }}</a>
                </div>
                <div class="widget-products__prices">
                    <ng-container *ngIf="product.compareAtPrice">
                        <span class="widget-products__new-price">{{ product.taxedPrice || product.price|currencyFormat }}</span>{{ ' ' }}
                        <span class="widget-products__old-price">{{ product.compareAtPrice|currencyFormat }}</span>
                    </ng-container>
                    <ng-container *ngIf="!product.compareAtPrice">
                        {{ product.taxedPrice || product.price|currencyFormat }}
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
